import api from './BaseApi';

export const createGates = async (data) => {
    try {
        const response = await api.post('/admin/gates', data);
        return response; 
    } catch (error) {
        console.error('Create gate error:', error);
        return error;
    }
};

export const getGates = async (params) => {
    try {
        const response = await api.get('/admin/gates', { params });
        return response.data;
    } catch (error) {
        console.error('Get gates error:', error);
    }
};

export const getSingleGate = async (id) => {
    try {
        const response = await api.get(`/admin/gates/${id}`);
        return response.data;
    } catch (error) {
        console.error('Get gate error:', error);
    }
};

export const updateGate = async (id, payload) => {
    try {
        const response = await api.put(`/admin/gates/${id}`, payload);
        return response;
    } catch (error) {
        console.error('Update gate error:', error);
        return error;
    }
};

export const deleteGate = async (id) => {
    try {
        const response = await api.delete(`/admin/gates/${id}`);
        return response.data;
    } catch (error) {
        console.error('Delete gate error:', error);
        return error;
    }
};

export const getGatesMetaData = async (params) => {
    try {
        const response = await api.get('/admin/gates/metadata', { params });
        return response.data;
    } catch (error) {
        console.error('Get gates meta error:', error);
    }
};